/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/core/Events',
	'../../widgets/livewidget/nls/StringResources'
], function(Events, stringResources) {
	'use strict';
	var FilterAction = null;
	var ACTION_ID = 'filterAction';
	FilterAction = Events.extend({
		init: function(visualization, slot, index, dashboardApi, logger) {
			FilterAction.inherited('init', this, arguments);
			this.visualization = visualization;
			this.slot = slot;
			this.mapIndex = index;
			this.dashboardApi = dashboardApi;
			this.logger = logger;


			const dataItem = slot.getDataItemList()[this.mapIndex];
			this.itemContext = {
				uniqueId: dataItem.getId(),
				itemId: dataItem.getColumnId(),
				itemName: dataItem.getLabel(),
				dataType: dataItem.getDataType(),
				aggregationType: dataItem.getAggregation(),
				sourceId: this.visualization.getDataSource().getId()
			};
			// Since only one named set from same dimension is allowed to be dropped, the itemId is unique.
			var metadataColumn = dataItem.getMetadataColumn();
			if (metadataColumn && metadataColumn.isNamedSet &&  metadataColumn.isNamedSet()) {
				this.itemContext.isNamedSet = true;
			}

			this.renderModule = this.getEditorModuleName();
			let strResText = stringResources.get('toolbarActionFilter');
			const iconsFeature = this.dashboardApi.getFeature('Icons');
			const filterIcon = iconsFeature.getIcon('common-filter');

			this.toolbarContribution = [{
				name: 'filter',
				text: strResText,
				label: strResText,
				icon: filterIcon.id,
				type: 'NextView',
				group: ACTION_ID,
				viewModule: this.renderModule,
				viewOptions: this.getViewOptions.bind(this)
			}];
		},

		getActionId: function() {
			return ACTION_ID;
		},

		/**
		 * get the set of availableSort actions setting the selected state to match
		 * the state of the data.
		 * @returns the sort actions and their state.
		 */
		getAvailableActions: function() {
			return this.toolbarContribution;
		},

		getViewOptions: function() {
			var options = {
				height: 300,
				width: 212, // those are hints only; for the placement of the toolbar.
				slot: this.slot,
				mapIndex: this.mapIndex,
				logger: this.logger,
				itemContext: this.itemContext,
				dashboardApi: this.dashboardApi,
				visualization: this.visualization
			};
			return options;
		},

		/**
		 * @returns a path to the editor dialog to be loaded.
		 */
		getEditorModuleName: function() {
			return 'dashboard-analytics/dialogs/CommonViewWrapper';
		}
	});

	return FilterAction;

});
